<template>
    <!-- <Card :dis-hover="true">
        <Tabs v-model="saleType"
            :animated="false"
            :capture-focus="true">
             <TabPane label="现售发货单"
                name="curSale">
                <CurSaleDeliveryList v-if="saleType ==='curSale'"
                    ref="curSaleDeliveryList" />
            </TabPane>
            <TabPane label="预售发货单"
                name="preSale">
                <PreSaleDeliveryList v-if="saleType==='preSale'"
                    ref="preSaleDeliveryList" />
            </TabPane>
        </Tabs>
    </Card> -->

		<Row :gutter="16">
		  <Col span="24" label="发货单列表" name="preSaleDelivery">
			<div class="global-tool-bar">
				<PreSaleDeliveryList  v-model="preSaleDelivery"
							ref="preSaleDeliveryList" />
		</div>
	    </Col>
	</Row>
</template>

<script>
import PreSaleDeliveryList from '../../preSale-management/preSale-delivery/preSale-delivery-list';
// import CurSaleDeliveryList from '../../curSale-management/curSale-delivery/curSale-delivery-list';

export default {
    name: 'deliveryList',
    components: {
        PreSaleDeliveryList
        // CurSaleDeliveryList
    },
    data() {
        return {
            preSaleDelivery: 'preSaleDelivery'
        };
    },
    mounted() {
    },
    methods: {
    }
};
</script>

<style scoped>
</style>
